import { InternalUserSubmissionPermissionParentFormGroup } from '../forms/internal-user-submission-permission-parent-form-group';
import { MemberSubmissionPermissionUtils } from '../../../../../../utils/submission-permission-utils/member-submission-permission-utils';
import { SubmissionTypeEnum } from '../../../../../../models/users/enum/submission-type-enum';
import { EmployerSubmissionTypeEnum } from '../../../../../../models/enum/shared/employer-submission-type.enum';
import { EmployerSubmissionPermissionUtils } from '../../../../../../utils/submission-permission-utils/employer-submission-permission-utils';

export class InternalUserSubmissionPermissionFormStateUtils {
  static readonly PERMANENTLY_DISABLED_IDS: number[] = [
    MemberSubmissionPermissionUtils.getCanCreateSubmissionPermission(SubmissionTypeEnum.MemberSelfEnrolment),
    MemberSubmissionPermissionUtils.getCanApproveOwnSubmissionPermission(
      SubmissionTypeEnum.VariableBenefitConfiguration
    ),
    MemberSubmissionPermissionUtils.getCanApproveOwnSubmissionPermission(SubmissionTypeEnum.AnnuitySetup),
    EmployerSubmissionPermissionUtils.getCanCreateSubmissionPermission(EmployerSubmissionTypeEnum.EmployerSelfEnrolment)
  ];

  static readonly ID_DEPENDENCIES: Array<{ id: number; requiresId: number }> = [
    {
      id: MemberSubmissionPermissionUtils.getCanCreateSubmissionPermission(
        SubmissionTypeEnum.VariableBenefitConfiguration
      ),
      requiresId: MemberSubmissionPermissionUtils.getProcessSubmissionPermission(
        SubmissionTypeEnum.VariableBenefitConfiguration
      )
    }
  ];

  static isPermanentlyDisabled(id: number): boolean {
    return InternalUserSubmissionPermissionFormStateUtils.PERMANENTLY_DISABLED_IDS.includes(id);
  }

  static reapplyDisabledState(fg: InternalUserSubmissionPermissionParentFormGroup): void {
    const { memberSubmissions, employerSubmissions } = fg.controls;
    for (const array of [memberSubmissions, employerSubmissions]) {
      for (const typeGroup of array.controls) {
        for (const permGroup of typeGroup.controls.submissionPermissions.controls) {
          if (InternalUserSubmissionPermissionFormStateUtils.isPermanentlyDisabled(permGroup.controls.id.value)) {
            permGroup.disable({ emitEvent: false });
          }
        }
      }
    }
  }
}
